@if (hasPermissions && clickable) {
<mat-card
  appearance="outlined"
  class="widget__container"
  (dblclick)="onClickWidget()"
  matRipple
>
  @if (isLoading || !loggedUserInfo) {
  <mat-card-content>
    <app-count-widget-skeleton></app-count-widget-skeleton>
    <div
      [style.background-color]="barBackground"
      id="color-bar-background"
      class="color-bar"
    ></div>
  </mat-card-content>
  } @if (!isLoading && hasFailed && !loggedUserInfo) {
  <mat-card-content class="widget__content">
    <div class="load-error">
      <div class="error-content">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <div class="error-message">
          <div class="pl-1 error-text">
            <span class="failed-message-bold">{{
              'widgets.error.failed-to-load' | translate
            }}</span>
            <span class="failed-message">{{
              'widgets.error.refresh' | translate
            }}</span>
          </div>
        </div>
        <button mat-icon-button (click)="refreshWidget()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
  } @if (!hasFailed && !isLoading && loggedUserInfo) {
  <mat-card-content>
    <div class="widget__content">
      <div class="widget-details">
        <div class="card-details ml-3">
          <span class="count">
            {{ value?.toLocaleString('en-US') }}
          </span>
          <div class="description">
            {{ widget?.title | translate }}
          </div>
        </div>
      </div>
      <div>
        <button mat-icon-button (click)="refreshWidget()">
          <mat-icon>refresh</mat-icon>
        </button>
        @if (widget?.subtitle) {
        <div class="sub-container">
          <span [style.color]="barBackground" class="sub-value" id="sub-value">
            {{ subValue?.toLocaleString('en-US') }}
          </span>
          <div class="sub-title">
            {{ widget?.subtitle | translate }}
          </div>
        </div>
        }
      </div>
    </div>
    <div
      id="color-bar-background"
      [style.background-color]="barBackground"
      class="color-bar"
    ></div>
  </mat-card-content>
  }
</mat-card>
} @if (hasPermissions && !clickable) {
<mat-card appearance="outlined" class="widget__container">
  @if (isLoading) {
  <mat-card-content>
    <app-count-widget-skeleton></app-count-widget-skeleton>
    <div
      id="color-bar-background"
      [style.background-color]="barBackground"
      class="color-bar"
    ></div>
  </mat-card-content>
  } @if (!isLoading && hasFailed) {
  <mat-card-content>
    <div class="widget__content">
      <div class="load-error">
        <div class="error-content">
          <mat-icon class="error-icon">error_outline</mat-icon>
          <div class="error-message">
            <div class="pl-1 error-text">
              <span class="failed-message-bold">{{
                'widgets.error.failed-to-load' | translate
              }}</span>
              <span class="failed-message">{{
                'widgets.error.refresh' | translate
              }}</span>
            </div>
          </div>
          <button mat-icon-button (click)="refreshWidget()">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
  } @if (!hasFailed && !isLoading) {
  <mat-card-content>
    <div class="widget__content">
      <div class="widget-details">
        <div class="card-details ml-3">
          <span class="count">
            {{ value?.toLocaleString('en-US') }}
          </span>
          <div class="description">
            {{ widget?.title | translate }}
          </div>
        </div>
      </div>
      <div>
        <button mat-icon-button (click)="refreshWidget()">
          <mat-icon>refresh</mat-icon>
        </button>
        @if (widget?.subtitle) {
        <div class="sub-container">
          <span [style.color]="barBackground" class="sub-value" id="sub-value">
            {{ subValue?.toLocaleString('en-US') }}
          </span>
          <div class="sub-title">
            {{ widget?.subtitle | translate }}
          </div>
        </div>
        }
      </div>
    </div>
    <div
      id="color-bar-background"
      [style.background-color]="barBackground"
      class="color-bar"
    ></div>
  </mat-card-content>
  }
</mat-card>
}
